export default __webpack_public_path__ + "static/media/GR00055-owl_75.7c6b0967.svg";